import Widget from '@/plugins/dashboard/widgets/Consignments/Widget'
import Configure from '@/plugins/dashboard/widgets/Consignments/Configure'
import Chart from '@/plugins/dashboard/classes/Chart'

export default class extends Chart {
  static name = 'Consignments'
  static widget = Widget
  static configure = Configure
}
